import { useState, useEffect } from 'react'
import { useAppSelector } from '../hooks/useAppDispatch'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Tabs } from '../components/ui'
import { SettingsProfile }    from '../features/settings/SettingsProfile'
import { SettingsAppearance } from '../features/settings/SettingsAppearance'
import { SettingsAccount }    from '../features/settings/SettingsAccount'
import { SettingsBilling }    from '../features/settings/SettingsBilling'
import s from '../styles/pages/SettingsPage.module.css'

type Tab = 'profile' | 'appearance' | 'billing' | 'account'

const TABS: { key: Tab; label: string }[] = [
  { key: 'profile',    label: 'Profile' },
  { key: 'appearance', label: 'Appearance' },
  { key: 'billing',    label: 'Billing' },
  { key: 'account',    label: 'Account' },
]

export default function SettingsPage() {
  const { user } = useAppSelector((s) => s.auth)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const [activeTab, setActiveTab] = useState<Tab>(TABS.some(t => t.key === tabParam) ? (tabParam as Tab) : 'profile')

  useEffect(() => {
    if (!user) void navigate('/')
  }, [user, navigate])

  if (!user) return null

  return (
    <div>
      <h1 className={s.pageTitle}>⚙️ Settings</h1>
      <Tabs tabs={TABS} active={activeTab} onChange={(t) => setActiveTab(t as Tab)} />

      {activeTab === 'profile'    && <SettingsProfile />}
      {activeTab === 'appearance' && <SettingsAppearance />}
      {activeTab === 'billing'    && <SettingsBilling />}
      {activeTab === 'account'    && <SettingsAccount />}
    </div>
  )
}
